import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { HomeService } from "../../services/home.service";

export const fetchSlider = createAsyncThunk(
  "slider/fetchSlider",
  async (_, { rejectWithValue }) => {
    try {
      const response = await HomeService.GetSlider();
      if (response && response.status === 200) {
        const newData = response.data.data;
        const oldDataString = sessionStorage.getItem("sliderData");
        const newDataString = JSON.stringify(newData);

        if (oldDataString === newDataString) {
          return newData;
        }

        sessionStorage.setItem("sliderData", newDataString);
        return newData;
      } else {
        return rejectWithValue("Failed to load slider");
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const sliderSlice = createSlice({
  name: "slider",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSlider.pending, (state) => {
        if (!state.data.length) state.loading = true;
      })
      .addCase(fetchSlider.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchSlider.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default sliderSlice.reducer;
